import { h } from "omi";

import { IconProps } from "@/wc/components";

export function CheckCircleOutlineIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 18" width={width} height={height}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.36654"
        d="M5.12443 9.02018 7.17423 11.07l4.09957-4.09962m3.758 2.0498c0 3.77362-3.0591 6.83272-6.83266 6.83272-3.77359 0-6.83268-3.0591-6.83268-6.83272 0-3.77358 3.05909-6.83268 6.83268-6.83268 3.77356 0 6.83266 3.0591 6.83266 6.83268Z"
      />
    </svg>
  );
}
